import { createFileRoute } from "@tanstack/react-router";

import OrgLocations from "~/pages/Administration/OrgLocations";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/administration/locations")({
  staticData: ROUTE_STATIC.administration,
  component: OrgLocations,
});
